import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'button-usage',
  templateUrl: './button-usage.component.html',
  styleUrls: ['./button-usage.component.sass']
})
export class ButtonUsageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
